import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { getDirecteur, deleteDirecteur } from './directeur.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const DirecteurDeleteModal = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const directeur = useAppSelector(state => state.directeur.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getDirecteur(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/directeur/${currentEcole && currentEcole.id}`);
  };

  const confirmDelete = event => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
      directeurAuthority: directeur.directeurAuthority,
    };
    dispatch(deleteDirecteur(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      {directeur.id !== null && (
        <Modal
          title="Confirmation de suppression"
          centered
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
            <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
              Supprimer
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          Etes-vous certain de vouloir supprimer le directeur {directeur.firstName} {directeur.lastName} ?
        </Modal>
      )}
    </>
  );
};

export default DirecteurDeleteModal;
